export default [
    {
        path: "/registration",
        component: () => import('../views/Registration.vue'),
        name: "Registration"
    },
    {
        path: "/refill",
        component: () => import('../views/Refill.vue'),
        name: "Refill"
    },
    {
        path: '*',
        redirect: '/registration'
    }
]